import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Loader } from '@els/els-react--loader';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import { init } from './ShibLoginControllerActions';

function ShibLogin(props) {
  const { providerId, shibbolethToken, grantType } = props;

  useEffect(() => {
    init(providerId, shibbolethToken, grantType);
    RouteChangeTracking.trackOnRouteChangeSuccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Loader />;
}

ShibLogin.propTypes = {
  providerId: PropTypes.string,
  shibbolethToken: PropTypes.string,
  grantType: PropTypes.string,
};

export default ShibLogin;
